import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getBrandCampaignFailure, getBrandCampaignSuccess } from '../../actions/CreateCampaignActions/getBrandCampaignActions';

function* getBrandCampaign({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getBrandCampaign + "?brandId=" + payload.brandId,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_BRAND_CAMPAIGN_SUCCESS status :", response.data.status);
        console.log("GET_BRAND_CAMPAIGN_SUCCESS data :", response.data.response);
        console.log("GET_BRAND_CAMPAIGN_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getBrandCampaignSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_BRAND_CAMPAIGN_FAILURE status :", error?.response?.status);
        console.log("GET_BRAND_CAMPAIGN_FAILURE data:", error?.response?.data);
        console.log("GET_BRAND_CAMPAIGN_FAILURE error :", error);
        console.log('====================================');
        yield put(getBrandCampaignFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getBrandCampaignSaga() {
    yield takeLatest(actionTypes.GET_BRAND_CAMPAIGN_REQUEST, getBrandCampaign);
}

export default getBrandCampaignSaga;